<template>
  <div class="footer">
    SeenThis Visual Identity
    <br>Need help?
      <a href="mailto:brand@seenthis.co">brand@seenthis.co</a>
    <img class="logo" src="/logos/logo-white.svg">
    <div class="session">Logged in as {{GoogleUser.email}} —
      <span @click="logout">Logout</span>
    </div>
  </div>
</template>

<script>
import { removeAuth } from '@/utils/authManager';


export default {
  name: 'Footer',
  methods: {
    logout() {
      removeAuth();
      window.location.href = '/';
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .footer
    background-color: $green
    padding: 40px
    color: #fff
    font-size: 22px
    line-height: 1.35em
    position: relative

    a
      color: $white
      font-weight: 600

      &:hover
        text-decoration: underline

  .logo
    width: 74px
    height: 51px
    position: absolute
    bottom: 40px
    right: 40px

  .session
    margin-top: 40px
    font-size: 14px
    span
      cursor: pointer
      color: $white
      font-weight: 600

</style>
